import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
    MatMomentDateModule,
    MomentDateAdapter,
} from '@angular/material-moment-adapter';
import * as shared from './';
import { I18nPipe } from './pipes/i18n.pipe';
import {
    MAT_DATE_LOCALE,
    DateAdapter,
    MAT_DATE_FORMATS,
} from '@angular/material/core';
import { GoogleMapsModule } from '@angular/google-maps';

const MY_FORMATS = {
    parse: {
        dateInput: 'L',
    },
    display: {
        dateInput: 'L',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    providers: [
        I18nPipe,
        { provide: MAT_DATE_LOCALE, useValue: 'fr' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    declarations: [...shared.components, ...shared.directives, ...shared.pipes],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatTooltipModule,
        GoogleMapsModule,
    ],
    exports: [...shared.components, ...shared.directives, ...shared.pipes],
})
export class SharedModule {}
